import { useContext, useEffect } from "react";
import Context from "../../storage/context";
import './style.css';

export default function FavoritesModal() {
    const ctx = useContext(Context);
    const count = ctx.getArrFavCars.length;

    const handlerClick = () => {
        if (count !== 0) {
            document.getElementById("cars-section").scrollIntoView({ behavior: "smooth" });
            ctx.setFavCars(!ctx.getFavCars)
        }
    }

    useEffect(() => {
        if (ctx.getArrFavCars.length === 0 && ctx.getFavCars) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            ctx.setFavCars(false)
        }

    }, [ctx.getArrFavCars])

    return (
        <button className="favorites-btn" onClick={handlerClick}>
            {ctx.getFavCars && count !== 0 ? (
                <>🚫 בטל סינון מועדפים</>
            ) : count > 0 ? (
                <>
                    ❤️ הצג מועדפים שלי
                    <span className="favorites-badge">{count}</span>
                </>
            ) : (
                <>💔 אין מועדפים</>
            )}
        </button>
    );
}